import { Link } from 'react-router-dom';
import CardNB from '../ui-nb/CardNB';
import BadgeNB from '../ui-nb/BadgeNB';
import IconNB from '../ui-nb/IconNB';
import type { Order } from '../../hooks/useOrderQuery';

interface OrderCardProps {
  order: Order;
  href?: string;
}

const STATUS_VARIANT: Record<string, 'success' | 'warning' | 'info' | 'error'> = {
  Received: 'info',
  Diagnosing: 'warning',
  'Waiting for part': 'warning',
  'In repair': 'info',
  Testing: 'info',
  'Ready for delivery': 'success',
  Delivered: 'success',
};

const PRIORITY_LABEL: Record<string, string> = {
  urgent: 'Urgent',
  normal: 'Normal',
};

export default function OrderCard({ order, href }: OrderCardProps) {
  const displayStatus = order.status || order.status_config?.name || 'Unknown';
  const statusVariant = STATUS_VARIANT[displayStatus] || 'info';

  const cardContent = (
    <CardNB variant="interactive" className="p-5">
      <div className="flex items-start justify-between mb-3">
        <div>
          <span className="text-sm font-mono text-nb-text-muted">{order.release_code || order.id}</span>
          <h3 className="font-semibold text-black">
            {order.device || 'Unknown device'}
            {order.device_model ? ` ${order.device_model}` : ''}
          </h3>
          <p className="text-sm text-nb-text-muted">
            {order.customer_name || 'Unknown customer'}
          </p>
        </div>
        <div className="flex flex-col items-end gap-2">
          <BadgeNB variant={statusVariant} size="sm">
            {displayStatus}
          </BadgeNB>
          {order.priority === 'urgent' && (
            <BadgeNB variant="error" size="sm">
              Urgent
            </BadgeNB>
          )}
        </div>
      </div>
      <div className="flex items-center justify-between text-sm">
        <span className="text-nb-text-muted">Est. delivery</span>
        <span className="font-medium text-black">
          {order.estimated_date
            ? new Date(order.estimated_date).toLocaleDateString('es-ES', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
              })
            : 'Not set'}
        </span>
      </div>
    </CardNB>
  );

  if (href) {
    return (
      <Link to={href} className="block">
        {cardContent}
      </Link>
    );
  }

  return cardContent;
}